export enum SessionStorageType {
	CrossDomain,
	Local,
	COOKIES,
}
